// Paged horizontal scroller for a row that would otherwise only be reachable by
// dragging — the category pills. The row keeps working without JS: it is a
// plain overflow-x container, and the buttons only appear once this upgrades it.

const SCROLL_FRACTION = 0.8; // page by most of a screenful, keeping context
const EDGE_TOLERANCE = 2; // sub-pixel rounding at the ends

class ScrollRow extends HTMLElement {
  connectedCallback() {
    this.viewport = this.querySelector('[data-scroll-row-viewport]');
    this.prev = this.querySelector('[data-scroll-row-prev]');
    this.next = this.querySelector('[data-scroll-row-next]');
    if (!this.viewport) return;

    this.prev?.addEventListener('click', () => this.page(-1));
    this.next?.addEventListener('click', () => this.page(1));

    this.onScroll = () => this.updateButtons();
    this.viewport.addEventListener('scroll', this.onScroll, { passive: true });

    // Track size changes: a wider window can make the row fit entirely, and
    // then the buttons should disappear.
    if ('ResizeObserver' in window) {
      this.observer = new ResizeObserver(() => this.updateButtons());
      this.observer.observe(this.viewport);
    }

    this.dataset.ready = 'true';
    this.scrollActiveIntoView();
    this.updateButtons();
  }

  disconnectedCallback() {
    this.viewport?.removeEventListener('scroll', this.onScroll);
    this.observer?.disconnect();
  }

  // On a category page the current pill can start off-screen; bring it into
  // view without scrolling the page itself.
  scrollActiveIntoView() {
    const active = this.viewport.querySelector('[aria-current="page"], .category-nav__pill--active');
    if (!active) return;
    const offset = active.offsetLeft - (this.viewport.clientWidth - active.offsetWidth) / 2;
    this.viewport.scrollLeft = Math.max(0, offset);
  }

  page(direction) {
    this.viewport.scrollBy({
      left: direction * this.viewport.clientWidth * SCROLL_FRACTION,
      behavior: 'smooth',
    });
  }

  updateButtons() {
    const { scrollLeft, scrollWidth, clientWidth } = this.viewport;
    const overflows = scrollWidth - clientWidth > EDGE_TOLERANCE;
    this.toggleAttribute('data-overflowing', overflows);

    if (this.prev) this.prev.disabled = !overflows || scrollLeft <= EDGE_TOLERANCE;
    if (this.next) {
      this.next.disabled = !overflows || scrollLeft + clientWidth >= scrollWidth - EDGE_TOLERANCE;
    }
  }
}

if (!customElements.get('scroll-row')) {
  customElements.define('scroll-row', ScrollRow);
}
